import EscPosEncoder from 'esc-pos-encoder-ionic-redjar';
import { ItemInOrderOutputDto, OrderOutputDto } from '../../generated_client';
import { format } from 'date-fns';
import es from 'date-fns/locale/es';

const paddingRight = (target): string => {
  let padd = '    ';
  padd += target;
  return padd;
};

const encodeOrderItems = (
  items: ItemInOrderOutputDto[],
  encoder: EscPosEncoder
) => {
  encoder.align('left').newline();
  items.forEach((item) => {
    const itemline = item.nmQuantity + '    ' + item.dsName;
    const price = `$${item.qtPrice}`;
    encoder.text(itemline, 48).text(paddingRight(price)).newline();

    const addons = item['addons'] || [];

    for (const addon of addons) {
      const addonLine = '    ' + addon.nmQty + '    ' + addon.dsName;
      const addonPrice = `$${addon.qtPrice}`;
      encoder.text(addonLine, 48).text(paddingRight(addonPrice)).newline();
    }
  });
  return encoder;
};

export const printOrder = (order: OrderOutputDto, paymentMethod: string) => {
  const appName = 'DeliApp';
  const storeName = order.dsStoreName;
  const orderNumber = order.cdOrder;
  const separator = '--------------------------------';
  const delay = order.nmStoreDelayMinutes;
  const user = {
    name: order.dsName,
    address: order.dsAddress,
    phone: order.dsPhone,
  };

  const encoder = new EscPosEncoder();
  let result = encoder.initialize();
  result
    .align('center')
    .size(2, 2)
    .line(appName)
    .size(1, 1)
    .line(storeName)
    .line('Orden')
    .line(orderNumber)
    .line(delay + ' Minutos')
    .line(separator)
    .line(user.name)
    .line(user.address, 48)
    .line('Tel: ' + user.phone)
    .line(separator)
    .align('left')
    .line('Medio de pago: ' + paymentMethod)
    .line(separator);

  result = encodeOrderItems(order.itemInOrderOutputDtos, result);
  if (order.dsDnotes) {
    result.align('left').line(order.dsNotes);
  }
  result.align('center');
  result.line(separator);
  const currentDate = format(new Date(), 'dd MMMM yyyy - HH:mm', {
    locale: es,
  });
  const sub = 'Subtotal:';
  const tot = 'Total:';
  const subTotal = `$${order.qtTotal}`;
  const del = 'Costo Envio:';
  const delQt = `$${order.qtDCharges}`;
  const total = `$${order.qtTotal + order.qtDCharges}`;
  result
    .newline()
    .align('left')
    .text(sub)
    .text(paddingRight(subTotal))
    .newline()
    .text(del)
    .text(paddingRight(delQt))
    .newline()
    .align('center')
    .newline()
    .size(2, 2)
    .line(`${tot} ${total}`)
    .size(1, 1)
    .line(separator)
    .line(currentDate, 38)
    .newline()
    .cut()
    .newline();

  const resultByte: Uint8Array = result.encode();
  return resultByte;
};
